/**
 * Rótulos dos estados de uma indicação (public/api/referral/ReferralService.php).
 */

export const REFERRAL_STATUS = {
  invited: { label: 'Convidado', tone: 'neutral' },
  signed_up: { label: 'Criou conta', tone: 'info' },
  subscribed: { label: 'Assinou, crédito a caminho', tone: 'success' },
  rewarded: { label: 'Crédito aplicado', tone: 'success' },
};

/**
 * @param {string} status
 * @returns {{ label: string, tone: string }}
 */
export function referralStatus(status) {
  return REFERRAL_STATUS[status] || REFERRAL_STATUS.invited;
}

/**
 * Link de indicação da conta, no domínio em que o app está aberto.
 * @param {string} code
 * @returns {string}
 */
export function referralLink(code) {
  return `${window.location.origin}/i/${code}`;
}

/**
 * Texto pronto para compartilhar o link.
 * @param {string} code
 * @returns {string}
 */
export function referralShareMessage(code) {
  return (
    'Eu uso a Gabriela para organizar minha agenda, meus atendimentos e as mensagens de ' +
    'confirmação no WhatsApp. Acho que vai te ajudar também. Teste grátis por 30 dias pelo ' +
    'meu link: ' + referralLink(code)
  );
}

/**
 * 'Y-m-d H:i:s' -> "16/10/2026".
 * @param {string|null} value
 * @returns {string}
 */
export function formatReferralDate(value) {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR');
}
